import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // new import
import './assets/fontawesome/css/all.css';
import './assets/fontawesome/css/fontawesome_6.0.css';
import './index.scss';
import App from './App';

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
    <App />
);

